import React, { useContext, useState } from 'react';
import { UserContext } from '../../../context/UserContext';
import client from '../../../lib/client';
import { changePasswordMutation } from '../../../queries/user';
import {
  ChangePasswordMutation,
  ChangePasswordMutationVariables
} from '../../../queries/__generated__/ChangePasswordMutation';
import { Input } from '../../forms';
import { Button, Card, CardSegment } from '../../ui';
import { toast } from 'react-toastify';

const UserPassword: React.FC = () => {
  const { user } = useContext(UserContext);
  const [newPassword, setNewPassword] = useState('');

  function saveUser() {
    client
      .mutate<ChangePasswordMutation, ChangePasswordMutationVariables>({
        mutation: changePasswordMutation,
        variables: {
          input: {
            userId: user.id,
            password: newPassword
          }
        }
      })
      .then(res => {
        if (!res.errors) {
          toast('Password updated!', { type: 'success' });
          setNewPassword('');
        }
      });
  }

  return (
    <Card className="mb2">
      <CardSegment className="pa4">
        <h3 className="f5 fw6 mt0 mb3">Change Password</h3>

        <Input
          className="mb3"
          value={newPassword}
          onChange={e => setNewPassword(e.target.value)}
          type="password"
          placeholder="Your new password..."
        />

        <Button onClick={saveUser}>Save</Button>
      </CardSegment>
    </Card>
  );
};

export default UserPassword;
